// extracted by mini-css-extract-plugin
export default {"dateRange":"IntegrationsQuickbooksSyncActivities_dateRange__od5iZ"};